/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useToken } from '../../../../../providers/Token.provider';
import styles from './FilteredBank.module.scss';
import { useDatadogLog } from '@/hooks/useDatadogLog';

export type FilteredBankProps = {
  FinancialInstitution: vp.FinancialInstitutionInfo;
  onClick?: () => void;
};

type FC = FunctionComponent<FilteredBankProps>;

const FilteredBank: FC = ({ FinancialInstitution, onClick }: FilteredBankProps) => {
  const { token } = useToken();
  const { i18n } = useTranslation('translations', { keyPrefix: 'SelectBank' });
  const { datadogLog } = useDatadogLog();

  const handleClick = () => {
    datadogLog({
      message: `${FinancialInstitution.FinancialInstitutionNumber} | ${FinancialInstitution.FIName} was selected`,
      payload: {
        label: 'FilteredBank',
        value: FinancialInstitution,
      },
      actionType: 'Input',
    });

    if (onClick) onClick();
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      {token?.Country === 'CA' && (
        <span className={styles.number}>
          {FinancialInstitution.FinancialInstitutionNumber || FinancialInstitution.FinancialInstitutionID} |
        </span>
      )}
      <span className={styles.title}>
        {i18n.language === 'en' ? FinancialInstitution.FIName : FinancialInstitution?.FINameFrench}
      </span>
      {token?.Country === 'CA' && <span> ({FinancialInstitution.ExternalFIID})</span>}
    </div>
  );
};

export default FilteredBank;
